module.exports = __webpack_public_path__ + "img/banner_head.52063673.png";